import React from 'react'
import Data from 'EurestoClass/Data'
import {Emoji} from 'emoji-mart'
import Tooltip from '@material-ui/core/Tooltip'
import Constants from 'EurestoFonction/Constants'

export default props => {
  const emoji = Data.get(Constants.module.SDD, Constants.donnee.flag, {id: props.flag}) || {}
  return <Tooltip disableTouchListener title={emoji.libelle}><Emoji emoji={emoji.icon} size={props.size || 12}/></Tooltip>
}



// WEBPACK FOOTER //
// ./app/Components/Emoji.js